var _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 539",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    style: {
      fill: "#ff7600"
    }
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "!",
    style: {
      fill: "#fff",
      fontSize: 12,
      fontFamily: "Swiss721BT-BoldCondensed,Swis721 Cn BT",
      fontWeight: 700,
      letterSpacing: ".05em"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 12
  }, "!")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.07326c298dd898a6aa86c0bfeeafd77a.svg";
export { ForwardRef as ReactComponent };